var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikelyRejectIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6809 -2274 24.8 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.707;}.b{fill:#fff;}.c{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-6877 -2411)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M467.6,280A12.4,12.4,0,1,1,480,292.5,12.42,12.42,0,0,1,467.6,280Z",
    transform: "translate(-399.6 -130.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M473,280.6h1.1V280h-.3a.882.882,0,0,1-.9-.8.817.817,0,0,1,.9-.8h.9v-.6h-.2a.8.8,0,1,1,0-1.6h.9v-.6h-.1a.806.806,0,1,1,0-1.6h5.1a9.431,9.431,0,0,1,2.7.9,5.162,5.162,0,0,0,1.8.6h2.9v6.2h-2.7c-1.2,0-1.9.5-3.5,1.9a6.388,6.388,0,0,0-1.9,4.7c0,.3-.4.4-.6.4-.3,0-1.1,0-1.1-1.7a10.483,10.483,0,0,1,1.1-4.2l.2-.5H473a.736.736,0,0,1-.8-.8A.765.765,0,0,1,473,280.6Z",
    transform: "translate(-399.6 -130.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikelyRejectIcn);
export default __webpack_public_path__ + "static/media/likely_reject_icn.fa92004fc9f9d7fca393141fab64812c.svg";
export { ForwardRef as ReactComponent };